async = require 'async'
initializeRichMarker = require './vendor/richmarker-compiled.js'
CrossSellBait = require '../../cross_sell_bait/frontend/cross_sell_bait'
CurrentLocation = require './current_location'
BrowserHistoryHandler = require '../../browser_history_handler/frontend/browser_history_handler'
MarkerTooltip = require './marker_tooltip'
OffersMapAddressInput = require './offers_map_address_input'
OffersMapCategoryFilters = require '../../offers_map_category_filters/frontend/offers_map_category_filters'
OffersMapFilters = require '../../offers_map_filters/frontend/offers_map_filters'
PlaceCard = require './place_card'

MOBILE_WEB_PINS_TO_SHOW_ON_MAP = 5

module.exports = class OffersMap

  templates:
    main: require '../main.html.mustache'
    mapMarker: require '../map_marker.html.mustache'
    goFullscreen: require '../go_fullscreen.html.mustache'
    tooltip: require '../tooltip.html.mustache'
    noPlacesFound: require '../no_places_found.html.mustache'

  constructor: ({ @el, @place, @config, @$mobileWrapper, @$desktopWrapper }) ->
    @$el = $ @el

    @cache = {}
    @cards = []
    @rootUrl = '/merchant-page/offers-map'
    @disableMapListeners = false
    @loadingCount = 0

    @history = new BrowserHistoryHandler('offers-map')
    @history.onPop @historyHandler

    @render()

    @$offersMap = @$el.find '.offers-map'
    @$cards = @$el.find '.place-cards'
    @$cardsOverflow = @$el.find '.place-cards-overflow'
    @$showingPlaces = @$el.find '.showing-x-places-long'
    @$showingPlacesShort = @$el.find '.showing-x-places-short'
    @$partialLoading = @$el.find '.partial-loading-overlay'
    @$fullLoading = @$el.find '.full-loading-overlay'
    @$searchWhenMapMoves = @$el.find '.search-when-map-moves input'
    @$noPlacesFound = @$el.find '.no-places-found'
    @$viewAllPlaces = @$el.find '.view-all-places'
    @$redoSearch = @$el.find '.redo-search-in-this-area'
    @$filterCount = @$el.find '.filter-count'

    @bindings()

    @setBaseTarget()
    @moveWidgetInit()
    @loadMapOnResize()
    @init()

  bindings: ->
    @bindFullscreenHandler()

    @$el.find('.filter-button').click =>
      @fullscreenHandler() unless @$offersMap.hasClass('fullscreen')
      @filters.showMobileModal()

    @$el.find('.map-button').click =>
      if @$offersMap.hasClass 'show-phone-map'
        @$offersMap.removeClass 'show-phone-map'
      else
        @fullscreenHandler() unless @$offersMap.hasClass('fullscreen')
        @$offersMap.addClass 'show-phone-map'

      @resize()

    @$redoSearch.click =>
      @fetchAndUpdatePlacesForMapInView()

    @currentLocation = new CurrentLocation {
      $el: @$el.find '.show-current-location'
      $error: @$el.find '.show-current-location-error-box'
    }

    if @config.showAddressInput
      @addressInput = new OffersMapAddressInput {
        $el: @$el.find '.address-input'
        $icon: @$el.find '.address-input-icon'
        offersMap: this
      }

  historyHandler: ({ action, placeId }) =>
    if @config.fullscreenOnly isnt true
      if not action? and @$offersMap.hasClass('fullscreen')
        @fullscreenHandler false
        @placePreviewDrawer?.hide false
        @placePreviewDrawer = null
      else if action is 'enter-fullscreen'
        @fullscreenHandler false
      else if action is 'exit-fullscreen'
        @fullscreenHandler false
        @placePreviewDrawer?.hide false
        @placePreviewDrawer = null
      else if action is 'place-preview-hide-modal'
        @placePreviewDrawer?.hide false
        @placePreviewDrawer = null
    else if action is 'place-preview-show-modal'
      for card in @cards
        if card.place.uuid is placeId
          card.showPreviewFromHistory()
          break
    else if action is 'place-preview-hide-modal'
      for card in @cards
        if card.place.uuid is placeId
          card.hidePreview false
          break
    else if not action?
      for card in @cards
        if card.isPlacePreviewShowingThisPlace()
          card.hidePreview false
          break

  isDesktopView: ->
    Modernizr.mq '(min-width: 768px)'

  setBaseTarget: ->
    # Open links on a separate window when the map is being rendered on /maps
    $('head').append('<base target="_blank" />') if @config.fullscreenOnly is true

  updatePlaceCardsWidth: ->
    # This logic is necessary for the mobile web horizontal scrolling.
    if not @isDesktopView() and @$offersMap.hasClass('show-phone-map')
      $placeCard = @$cards.find '.place-card'
      if $placeCard.length > 0
        width = $placeCard.length * $placeCard.outerWidth()
        @$cards.css 'width', "#{width}px"
    else
      @$cards.removeAttr 'style'

  resize: =>
    @updatePlaceCardsWidth()
    return unless @isMapVisible()

    if @map?
      google.maps.event.trigger @map, 'resize'
      setTimeout (=> @zoomToShowAllMarkers()), 500
    else
      @loadGoogleMaps (err) =>
        throw err if err?
        @createMap()
        @renderPlaces()
        @mapLoaded()

  loadMapOnResize: ->
    debounceTimeout = null
    $(window).on 'resize', =>
      clearTimeout(debounceTimeout) if debounceTimeout?
      debounceTimeout = setTimeout @resize, 300

  moveWidgetInit: ->
    return unless @$mobileWrapper?.length > 0
    debounceTimeout = null
    $(window).on 'resize', =>
      clearTimeout(debounceTimeout) if debounceTimeout?
      debounceTimeout = setTimeout @moveWidget, 250

    @moveWidget()

  moveWidget: =>
    # On Mobile, when the place has no offers, we move the Offes Map widget to the top.
    if @isDesktopView()
      return unless @$desktopWrapper.find(@$el).length is 0
      @$desktopWrapper.html @$el
      @$mobileWrapper.find(@$el).remove()
    else
      return unless @$mobileWrapper.find(@$el).length is 0
      @$mobileWrapper.html @$el
      @$desktopWrapper.find(@$el).remove()

  isMapVisible: ->
    # The second part is to avoid trying to load the Google Maps API when running
    # on a forbidden domain (or localhost, for running tests).
    (@isDesktopView() or @$offersMap.hasClass('show-phone-map')) and /(^|\.)groupon(\.)/.test(window.location.host)

  render: ->
    data = {}
    data.translate = data.t = -> (str) -> I18n.t str
    goFullscreenHtml = @templates.goFullscreen.render data

    @$el.html @templates.main.render(_.extend data, { goFullscreenHtml, config: @config })

    @filters = new OffersMapFilters { el: @$el.find('.offers-map-filters-wrapper'), config: @config, history: @history }
    @filters.onChange =>
      @renderPlaces()
      @updateFilterCount()

    @categoryFilters = new OffersMapCategoryFilters { el: @$el.find('.offers-map-category-filters-wrapper') }
    @categoryFilters.onChange => @fetchAndUpdatePlacesForMapInView()

    @$el

  init: ->
    async.auto {
      getLocation: (done) =>
        return done() unless @config.askForCurrentLocationOnLoad is true

        # Automatically ask for current location when using the /maps URL.

        doneCalled = false

        @currentLocation.onNewLocation (err, currentPosition) =>
          done(null, currentPosition) unless doneCalled
          doneCalled = true

        @currentLocation.watch()

        setTimeout (=>
          done() unless doneCalled
          doneCalled = true
        ), 2500

      getPlaces: ['getLocation', (done, results) =>
        currentPosition = results?.getLocation

        if currentPosition?.lat? and currentPosition?.lon?
          data = currentPosition
        else
          data = { lat: @place.lat, lon: @place.lon }

        # When setting dynamic_radius=true, the server will increase the radius if there are
        # not enough places in the given radius.
        data.dynamic_radius = true if @config.dynamicRadius is true

        @fetchPlaces data, (err, res) ->
          # Ignore errors, so that the "getGoogleMaps" task can finish.
          done null, res
      ]

      getGoogleMaps: (done) =>
        return done() unless @isMapVisible()

        @loadGoogleMaps (err) ->
          # TODO: gracefully handle error
          throw err if err?
          done()
    }, (err, { getPlaces }) =>
      @createMap() if @isMapVisible()
      @bindScrollHandler()

      @places = getPlaces?.places
      @renderPlaces()

      @mapLoaded() if @map?

      if @places?.length > 0
        if @config.showBait is true and @isDesktopView()
          setTimeout (=> @showBait()), 1000
      else
        @noPlacesFound()

      @$fullLoading.addClass 'hidden'

  loadGoogleMaps: (cb) ->
    Groupon.Utils.GoogleMaps.load (err) ->
      return cb(err) if err?
      # This needs to be called once window.google.maps is available.
      initializeRichMarker()
      cb()

  mapLoaded: ->
    @zoomToShowAllMarkers() if @places?.length > 0
    @addMapListeners()
    @addStarMarker()

  removeAllMarkers: ->
    card.destroy() for card in @cards
    @cards = []

  shouldHidePlaceCard: (card, filters) ->
    (filters.deals and not card.hasDeals()) or \
      (filters.onlineOrdering and not card.hasGdt()) or \
      (filters.openNow and not card.isOpenNow())

  renderPlaces: ->
    @$noPlacesFound.addClass 'hidden'
    @removeAllMarkers()
    @placePreviewDrawer?.hide()
    $placePreview = @$el.find '.place-preview-container'

    if @places?.length > 0
      filters = @filters.values()

      if filters.sortBy is 'distance'
        @sortByDistance()
      else if filters.sortBy is 'rating'
        @sortByRating()
      else
        @sortByRelevance()

      label = 0
      for i in [0...@places.length]
        label += 1
        card = new PlaceCard {
          offersMap: this
          place: @places[i]
          label: label
          map: @map
          $placePreview
          config: @config
          history: @history
        }

        if @shouldHidePlaceCard(card, filters)
          card.destroy()
          label -= 1
          continue

        @cards.push card
        @$cards.append card.render()

      if @cards.length > 0
        for i in [@cards.length-1..0]
          # We do this in reverse so that pin #1 shows up on top of pin #2 without having
          # to mess around with z-indexes.
          card = @cards[i]
          card.addMarker()

    @$cards.scrollTo { left: 0, top: 0 }
    @$cardsOverflow.scrollTo { left: 0, top: 0 }

    @scrollHandler()

    if @$cards.find('.place-card').length is 0
      @noPlacesFound()
      @$viewAllPlaces.addClass 'hidden'
    else
      @$viewAllPlaces.removeClass 'hidden'

    @updateNumberOfPlaces()
    @updatePlaceCardsWidth()

  fullscreenHandler: (saveInHistory = true) ->
    if @$offersMap.hasClass 'fullscreen'
      $('body').removeClass 'modal-open'
      @$offersMap.removeClass 'show-phone-map'
      @$offersMap.removeClass 'fullscreen'
      @map?.setOptions { scrollwheel: false }
      @history.add({ action: 'exit-fullscreen' }) if saveInHistory
    else
      $('body').addClass 'modal-open'
      @$offersMap.addClass 'fullscreen'
      @map?.setOptions { scrollwheel: true }
      @history.add({ action: 'enter-fullscreen' }) if saveInHistory

    if @map?
      google.maps.event.trigger @map, 'resize'
      setTimeout (=> @zoomToShowAllMarkers()), 500

  bindFullscreenHandler: ->
    @$el.find('.go-fullscreen, .view-all-places, .go-back').click => @fullscreenHandler()

  bindScrollHandler: ->
    debounce = null
    @$cards.add(@$cardsOverflow).scroll =>
      clearTimeout(debounce) if debounce?
      debounce = setTimeout @scrollHandler, 5

  updateFilterCount: ->
    count = @filters.values().count
    @$filterCount.text count
    if count > 0
      @$filterCount.addClass 'show'
    else
      @$filterCount.removeClass 'show'

  numberOfPinsToShowOnMap: ->
    if @isUsingHorizontalScrolling()
      MOBILE_WEB_PINS_TO_SHOW_ON_MAP
    else
      cardHeight = @$cards.find('.place-card:first-child').outerHeight()
      Math.floor(@$cards.outerHeight() / cardHeight)

  isUsingHorizontalScrolling: ->
    not @isDesktopView() and @$offersMap.hasClass('show-phone-map')

  scrollHandler: =>
    return unless @$cards.find('.place-card').length > 0
    @$el.find('.marker-label').removeClass('active') if @map?

    if @isUsingHorizontalScrolling()
      pixelsScrolled = - @$cards.position().left
      cardWidth = @$cards.find('.place-card:first-child').outerWidth()
      firstCardInView = Math.ceil((pixelsScrolled - cardWidth * 2 / 3) / cardWidth) + 1
      pinsToShowOnMap = @numberOfPinsToShowOnMap()
    else
      pixelsScrolled = - @$cards.find('.place-card:first-child').position().top
      cardHeight = @$cards.find('.place-card:first-child').outerHeight()
      firstCardInView = Math.ceil(pixelsScrolled / cardHeight) + 1
      pinsToShowOnMap = @numberOfPinsToShowOnMap()

    count = 0
    for card in @cards
      count += 1

      if card.marker?
        if count >= firstCardInView and count < firstCardInView + pinsToShowOnMap
          card.showPin()
        else
          card.showDot()

      # Load images for cards that are in view now and the ones that will be in view soon.
      if count >= firstCardInView - 2 and count <= firstCardInView + pinsToShowOnMap + 2
        card.showImage()

  updateNumberOfPlaces: ->
    data =
      highlightOpen: '<strong>'
      highlightClose: '</strong>'
      count: @$cards.find('.place-card').length
      placeName: @place.name

    if @place.name?
      # $.extend is necessary because of: https://github.groupondev.com/InteractionTier/grapefruit/issues/59
      html = I18n.t 'js.modules.offers_map.showing_x_places_near_place', $.extend {}, data
      htmlShort = I18n.t 'js.modules.offers_map.showing_x_places_near_place_short', $.extend {}, data
    else
      html = I18n.t 'js.modules.offers_map.showing_x_places', $.extend {}, data
      htmlShort = I18n.t 'js.modules.offers_map.showing_x_places_short', $.extend {}, data

    @$showingPlaces.html html
    @$showingPlacesShort.html htmlShort

  sortByRating: ->
    getRating = (place) ->
      recommendation = place.ugc?.recommendation
      if recommendation?.showToUser then recommendation.percentage else 0

    @places.sort (a, b) -> getRating(b) - getRating(a)

  sortByDistance: ->
    @places.sort (a, b) -> a.distance.value - b.distance.value

  sortByRelevance: ->
    @places.sort (a, b) -> a.relevanceOrder - b.relevanceOrder

  fetchPlaces: (data, cb) ->
    data.limit = if @isDesktopView() then @config.limit.desktop else @config.limit.mobile

    cacheKey = JSON.stringify data
    return cb(null, @cache[cacheKey]) if @cache[cacheKey]?

    $.ajax
      url: "#{@rootUrl}/places"
      type: 'GET'
      contentType: 'application/json'
      dataType: 'json'
      data: data
      success: (res) =>
        return cb(new Error(res?.error?.code)) unless res?.result is 'ok'

        # Store the original order, so that we can reset it if a filter is applied later.
        if res.data?.places?.length > 0
          for i in [0...res.data.places.length]
            res.data.places[i].relevanceOrder = i

        @cache[cacheKey] = res.data
        return cb null, res.data
      error: ->
        return cb(new Error('Request Failed'))

  zoomToShowAllMarkers: ->
    return unless @map? and @cards.length > 0

    bounds = new google.maps.LatLngBounds()

    for placeCard in @cards
      bounds.extend placeCard.marker.getPosition()

    # We disable the map listeners while adjusting the zoom to avoid triggering a new fetch.
    @disableMapListeners = true
    @map.fitBounds bounds
    setTimeout (=> @disableMapListeners = false), 1000

  createMap: ->
    coords = @currentLocation.get()

    if coords?
      center = new google.maps.LatLng coords.lat, coords.lon
    else
      center = new google.maps.LatLng @place.lat, @place.lon

    options =
      zoom: 13
      center: center
      mapTypeControl: false
      draggable: true
      scrollwheel: @$offersMap.hasClass('fullscreen')
      disableDefaultUI: true
      zoomControl: true
      zoomControlOptions:
        style: google.maps.ZoomControlStyle.SMALL
        position: google.maps.ControlPosition.LEFT_TOP
      mapTypeControl: false
      mapTypeControlOptions:
        mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.SATELLITE]
        position: google.maps.ControlPosition.RIGHT_TOP
      streetViewControl: false
      streetViewControlOptions:
        position: google.maps.ControlPosition.LEFT_BOTTOM
      styles: [{
        featureType: 'poi'
        stylers: [{ visibility: 'off' }] # Disable Google's "Points of Interest"
      }, {
        featureType: 'transit.station.bus'
        stylers: [{ visibility: 'off' }] # Disable bus stops
      }]

    @map = new google.maps.Map @$el.find('.map-container')[0], options

    @currentLocation.setMap @map

    @currentLocation.onNewLocation (err, currentPosition) =>
      return if err?
      @fetchAndUpdatePlacesForMapInView()

  addMapListeners: ->
    @map.addListener 'dragend', =>
      return if @disableMapListeners

      if @isDesktopView() and @$searchWhenMapMoves.is(':checked')
        @fetchAndUpdatePlacesForMapInView()
      else
        @$redoSearch.removeClass 'hidden'

    debounce = null
    @map.addListener 'zoom_changed', =>
      return if @disableMapListeners

      if @isDesktopView() and @$searchWhenMapMoves.is(':checked')
        clearTimeout(debounce) if debounce?
        debounce = setTimeout (=>
          @fetchAndUpdatePlacesForMapInView()
        ), 250
      else
        @$redoSearch.removeClass 'hidden'

  fetchAndUpdatePlacesForMapInView: ->
    @showLoading()
    @$redoSearch.addClass 'hidden'

    categoryId = @categoryFilters.value()

    if @map? and @isMapVisible()
      data =
        lat: @map.getCenter().lat()
        lon: @map.getCenter().lng()
        radius: @calculateRadiusInMeters()
    else
      data =
        lat: @place.lat
        lon: @place.lon

    data.categories = categoryId if categoryId?

    # This is in case requests arrive in the wrong order.
    @loadingCount += 1
    loadingCount = @loadingCount

    @fetchPlaces data, (err, data) =>
      return unless loadingCount is @loadingCount
      @places = data?.places
      @renderPlaces()
      @hideLoading()

  calculateRadiusInMeters: ->
    # We can't use the distance to one of the corners because the map might be a rectangle.
    # Instead, we need to calculate the minimun distance from the center to the north or the center to the east.

    bounds = @map.getBounds()
    center = bounds.getCenter()
    northEast = bounds.getNorthEast()
    east = new google.maps.LatLng center.lat(), northEast.lng()
    north = new google.maps.LatLng northEast.lat(), center.lng()

    distanceFromCenterToNorth = google.maps.geometry.spherical.computeDistanceBetween center, north
    distanceFromCenterToEast = google.maps.geometry.spherical.computeDistanceBetween center, east

    Math.floor(Math.min(distanceFromCenterToEast, distanceFromCenterToNorth))

  clearFilters: =>
    @filters.clear()
    @categoryFilters.clear()

  noPlacesFound: ->
    filters = @filters.values()
    categoryFilter = @categoryFilters.value()

    lineBreak = '<span class="line-break"></span>'

    if categoryFilter? or filters.deal or filters.onlineOrdering or filters.openNow
      message = I18n.t 'js.modules.offers_map.no_places_found.with_filters',
        clearLinkOpen: '<span class="clear-filters">'
        clearLinkClose: '</span>'
        lineBreak: lineBreak
    else
      message = I18n.t 'js.modules.offers_map.no_places_found.without_filters',
        lineBreak: lineBreak

    @$noPlacesFound.html @templates.noPlacesFound.render({ message })
    @$noPlacesFound.removeClass 'hidden'

    @$noPlacesFound.find('.clear-filters').click @clearFilters

  getTooltipRecommendationsString: ->
    return null unless @place.recommendations?.total > 0
    {total, percentage} = @place.recommendations
    I18n.t 'js.modules.offers_map.place_card.recommendations', { total, percentage }

  addStarMarker: ->
    return if @place.showMarker is false

    tooltipData =
      isMainMarker: true
      name: @place.name
      mainCategory: @place.category?.singular
      formattedLocation: @place.streetAddress?.replace /\.$/, ''
      translations:
        recommendations: @getTooltipRecommendationsString()

    data =
      label: '<span class="icon-star-filled"></span>'
      tooltipHtml: @templates.tooltip.render tooltipData

    $marker = $ @templates.mapMarker.render(data)
    $marker.find('.marker-label').addClass 'default-cursor'
    $tooltip = $marker.find '.marker-tooltip'

    @marker = new RichMarker
      position: new google.maps.LatLng @place.lat, @place.lon
      map: @map
      draggable: false
      shadow: false
      content: $marker[0]

    @tooltip = new MarkerTooltip
      marker: @marker
      $hoverElement: $marker.find '.marker-label'
      $mapContainer: @$el.find '.map-container'
      $tooltip: $tooltip
      $marker: $marker

    # This is necessary so that we only calculate the tooltip position after the map and marker are loaded
    setTimeout (=> @tooltip.show()), 1000

  showLoading: ->
    @$partialLoading.removeClass 'hidden'

  hideLoading: ->
    @$partialLoading.addClass 'hidden'

  showBait: ->
    new CrossSellBait { $offers: @$el }

  removeAllPlaceCardHighlights: ->
    card.removeHighlight() for card in @cards
